import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import connecting from 'src/public/img/connecting.png';
import emergency from 'src/public/img/emergency.png';
import information from 'src/public/img/information.png';
import { Button } from 'src/shared/components/Button';
import { Modal } from 'src/shared/components/Modal';
import { color, font, layout } from 'src/shared/styles/variables';

interface StyledIcon {
    iconUrl: string;
}

export const StyledIcon = styled('i')<StyledIcon>(({ iconUrl }) => ({
    backgroundImage: `url('${iconUrl}')`,
    width: '8rem',
    height: '8rem',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    marginRight: 25,
}));

const StyledModal = styled(Modal)({
    '& .ant-modal-content': {
        maxWidth: layout.modalWidth.medium,
        margin: '0 auto',

        '& .ant-modal-body': {
            padding: '4rem 5rem 3rem',
        },
    },
});

const HeadingText = styled.h3(
    {
        color: color.pickledBluewood,
        textAlign: 'left',
    },
    font.heavy(font.size.mediumExtended),
);

const DescriptionText = styled.p(
    {
        color: color.blueBayoux,
        textAlign: 'left',
    },
    font.medium(font.size.medium),
);

const ContentWrapper = styled.div({
    maxWidth: 490,
});

const ResourceContainer = styled.div({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
});

interface Props {
    visible: boolean;
    onToggle: () => void;
}

export enum CrisisResourceModalTestID {
    Modal = 'CrisisResourceModalTestID.Modal',
    Continue = 'CrisisResourceModalTestID.Continue',
}

export const CrisisResourceModal: React.FC<Props> = ({ onToggle, visible }) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <StyledModal
                wrapProps={{
                    'data-testid': CrisisResourceModalTestID.Modal,
                }}
                visible={visible}
                onCancel={onToggle}
                footer={null}
                width="auto"
                centered
            >
                <HeadingText>{t('onboarding:components.crisis_resource_modal.header')}</HeadingText>
                <ContentWrapper>
                    <ResourceContainer>
                        <StyledIcon iconUrl={emergency} />
                        <DescriptionText>
                            {t('onboarding:components.crisis_resource_modal.cardOne.text')}
                        </DescriptionText>
                    </ResourceContainer>
                    <ResourceContainer>
                        <StyledIcon iconUrl={connecting} />
                        <DescriptionText>
                            {t('onboarding:components.crisis_resource_modal.cardTwo.text')}
                        </DescriptionText>
                    </ResourceContainer>
                    <ResourceContainer>
                        <StyledIcon iconUrl={information} />
                        <DescriptionText>
                            {t('onboarding:components.crisis_resource_modal.cardThree.text')}
                        </DescriptionText>
                    </ResourceContainer>

                    <Button
                        onClick={onToggle}
                        type="accept"
                        marginTop={16}
                        loading={false}
                        disabled={false}
                        fullWidth
                        testID={CrisisResourceModalTestID.Continue}
                    >
                        {t('onboarding:components.crisis_resource_modal.button')}
                    </Button>
                </ContentWrapper>
            </StyledModal>
        </React.Fragment>
    );
};
